<app-search  class="sm:hidden mx:block"  (vehicleSelected)="vehicleSelected($event)"></app-search>
<div class="sm:hidden mx:flex" *ngIf="!isMobile()">
    <app-category style="overflow-y: auto;" (categorySelected)="categorySelected($event)"></app-category>
    <nz-spin nzTip="Loading..." [nzSpinning]="isSpinning" class="result">
      <div >
        <div class="flex-v-center mb20">
            <div class="search_type flex-between mr-5" *ngIf="title">
                <span>{{title}}</span>
                <svg-icon [iconName]="'del.svg'" [size]="16" class="del" (click)="deleteFilter()"></svg-icon>
            </div>
            <div>{{pagination.total}} {{"RESULTS" | translate}}</div>
        </div>
          <div class="result-table">
            <nz-table #fixedTable [nzScroll]="{ x: 'max-content' }" [nzFrontPagination]="false"  nzShowPagination [nzData]="productList" [nzTotal]="pagination.total"
              [nzPageIndex]="pagination.pageIndex" [nzPageSize]="pagination.pageSize"
              [nzPageSizeOptions]="pagination.pageSizeOptions" (nzPageIndexChange)="pageIndexChange($event)"
              (nzPageSizeChange)="pageSizeChange($event)">
              <thead>
                <tr>
                    <th nzWidth="120px"></th>
                    <th nzWidth="150px"> {{"MATERIA_NUM" | translate}}</th>
                    <th nzWidth="180px"> {{"ROLE_DESCRIPTION" | translate}}</th>
                    <th nzWidth="140px"> {{"STATUS" | translate}}</th>
                    <th nzWidth="80px"> {{"STOCK" | translate}}</th>
                    <th nzWidth="110px"> {{"QUANTITY" | translate}}</th>
                    <th nzWidth="120px" > <div class="text-center">{{"MOQ" | translate}}</div></th>
                    <th nzWidth="80px"  nzRight> {{"ACTION" | translate}}</th>
                </tr>
              </thead>
              <tbody class="order">
                <tr *ngFor="let data of productList" (click)="goDetail(data)" class="cursor-pointer">
                    <td>
                      <div *ngIf="data.images.length>0">
                        <img  [src]="data.images[0].imageURL100" />
                      </div>
                      <div *ngIf="data.images.length==0">
                        <img  src="assets/picture.svg" />
                      </div>
                        
                    </td>
                    <td> {{data.articleNumber}}</td>
                    <td>
                        <div>
                            <div class="font14-w700">{{data.genericArticles[0].genericArticleDescription}} <span *ngIf="data.misc?.additionalDescription"> |  {{data.misc?.additionalDescription}}</span></div>
                            <div class="font14-w500 flex" *ngIf="data.typeFormular">{{'ALIAS' | translate }}:&nbsp;&nbsp;	<div class=" flex"><span>{{data.typeFormular}}</span></div></div>
                            <div class="font14-w500 flex" *ngIf="data.tradeNumbers.length>0">Trade numbers:&nbsp;&nbsp;	<div class=" flex color-blue"><span class="trade" *ngFor="let trade of data?.tradeNumbers;let last = last" (click)="search(trade,$event)">{{trade}}{{ !last ? ' / ' : '' }}</span></div></div>
                            <div class="font14-w500 flex" *ngIf="data.replacesArticles.length>0">Replaces:&nbsp;&nbsp;<div class="color-blue"><span class="trade" *ngFor="let replaces of data?.replacesArticles;let last = last" (click)="search(replaces.articleNumber,$event)">{{replaces.articleNumber}}{{ !last ? ' / ' : '' }}</span></div></div>
                            <div class="font14-w500 flex" *ngIf="data.replacedByArticles.length>0">Replaced by:&nbsp;&nbsp; <div class="color-blue"><span class="trade" *ngFor="let replaced of data?.replacedByArticles;let last = last" (click)="search(replaced.articleNumber,$event)">{{replaced.articleNumber}}{{ !last ? ' / ' : '' }}</span></div></div>
                        </div>
                    </td>
                    <td>{{data.misc?.articleStatusDescription}}</td>
                    <td><svg-icon *ngIf="isLogin" [iconName]="data.stockQty ===0?'new/red.svg':(data.quantity<=data.stockQty ?'new/green.svg':'new/yellow.svg')" [size]="20"></svg-icon></td>
                    <td (click)="stopPropagation($event)">
                      <nz-input-group [nzSuffix]="suffixTemplateInfo" [nzPrefix]="prefixTemplateUser" class="quantity">
                        <input  type="number" nz-input  placeholder="" [(ngModel)]="data.quantity" min="0" step="1" (click)="stopPropagation($event)" (focus)="stopPropagation($event)" (blur)="onBlur($event,data)" (ngModelChange)="onInputChange($event)" />
                      </nz-input-group>
                      <ng-template #prefixTemplateUser>
                        <svg-icon *ngIf="!data.isHoveredMin"
                        (mouseenter)="data.isHoveredMin = true"
                        (mouseleave)="data.isHoveredMin = false" [iconName]="'new/minus-grey.svg'"    (click)="minusQuantity(data,$event)"></svg-icon>
                        <svg-icon *ngIf="data.isHoveredMin"
                        (mouseenter)="data.isHoveredMin = true"
                        (mouseleave)="data.isHoveredMin = false" [iconName]="'new/minus.svg'"   (click)="minusQuantity(data,$event)"></svg-icon>
                      </ng-template>
                      <ng-template #suffixTemplateInfo>
                        <svg-icon *ngIf="!data.isHoveredAdd"
                        (mouseenter)="data.isHoveredAdd = true"
                        (mouseleave)="data.isHoveredAdd = false"  [iconName]="'new/plus-grey.svg'"  (click)="addQuantity(data,$event)"></svg-icon>
                        <svg-icon *ngIf="data.isHoveredAdd"
                        (mouseenter)="data.isHoveredAdd = true"
                        (mouseleave)="data.isHoveredAdd = false"  [iconName]="'new/plus.svg'"   (click)="addQuantity(data,$event)"></svg-icon>
                      </ng-template>
                    </td>
                    <td>
                      <div class="text-center"> {{data.minumQty}}</div>
                     </td>
                    <td class="color-blue" nzRight>
                        <svg-icon  *ngIf="!data.isHoveredCart"
                        (mouseenter)="data.isHoveredCart = true"
                        (mouseleave)="data.isHoveredCart = false" [ngClass]="{'disabled':!isLogin || userData?.queryUserPageInfoResDTO?.status!==2}" [iconName]="'new/order-cart-add-grey.svg'" [attr.title]="'ADD_TO_CART' | translate" class="cursor-pointer"  (click)="addToCart(data,$event)"></svg-icon>
                        <svg-icon *ngIf="data.isHoveredCart"
                        (mouseenter)="data.isHoveredCart = true"
                        (mouseleave)="data.isHoveredCart = false" [ngClass]="{'disabled':!isLogin || userData?.queryUserPageInfoResDTO?.status!==2}" [iconName]="'new/order-cart-add.svg'" [attr.title]="'ADD_TO_CART' | translate" class="cursor-pointer"  (click)="addToCart(data,$event)"></svg-icon>     
                    </td>
                  </tr>
              </tbody>
            </nz-table>
            <ng-template #totalTemplate let-total>{{
              "TOTAL_ITEM" | translate : { total }
            }}</ng-template>
          </div>
    </div>
    </nz-spin>
</div>

<app-product-mobile-list class="sm:block mx:hidden"></app-product-mobile-list>